import { Box, Button, Typography } from "@mui/material";
import { useQuery } from "react-query";
import StatsCard from "src/components/common/StatsCard";
import defaultStyles from "../styles";
import { getStyles } from "src/styles/theme";
import {
  getEntityDashboardDetails,
  getTableDashboardDetails,
  getUserDashboardDetails,
} from "src/utils/api/dashboard";
import { DashBoardTable } from "src/components/common/DashBoardTable";
import {
  downloadSheet,
  exportEntityTableToXlsx,
  extractStates,
  formatData,
  formatDataForBarChart,
} from "src/utils/helper";
import DashboardChartSkeleton from "src/components/common/DashboardChartSkeleton";
import { useEffect, useMemo, useState } from "react";
import RenderTable from "../../Home/RenderTable";
import { AxiosError, AxiosResponse } from "axios";
import MultiSelect from "src/components/common/MultiSelect";
import { getStates } from "src/utils/api/roles";
import { entityDashboardtableColumns } from "src/constants/tableColumns";
import StatusBarChart from "src/components/common/StatusBarChart";
import { EntityDashBoardTable } from "src/components/common/DashBoardTable/entityDashboard";
import { usePersistedFilters } from "src/hooks/usePersistedFilters";
import { useEntityOptions } from "src/hooks/useEntityOptions";

const Entity = () => {
  const [isTabLoading, setIsTabLoading] = useState(true);
  const [topHeader, setTopHeader] = useState([""]);
  const [header, setHeader] = useState([""]);
  const [tableRows, setTableRows] = useState([]);
  const [filtersState, setFiltersState] = useState([]);
  const [filterEntities, setfilterEntities] = useState([]);

  const [states, setStates] = useState<any>([]);

  const { persisted, saveFilters } = usePersistedFilters("mw_entity");

  const [queryParams, setQueryParams] = useState<{
    offset: number;
    limit: number;
    sortBy: string;
    searchText: string;
    stateIds?: string[];
    entityIds?: string[];
    type: string;
  }>({
    offset: 0,
    limit: 50,
    sortBy: "state:ASC",
    searchText: "",
    stateIds: persisted?.queryParams?.stateIds ?? undefined,
    entityIds: persisted?.queryParams?.entityIds ?? undefined,
    type: "entityLandOwnership",
  });

  const [filterKey, setFilterKey] = useState(
    persisted?.filterKey ?? { projectStateIds: null }
  );

  const [entityfilterKey, entitySetFilterKey] = useState(
    persisted?.entityfilterKey ?? { enetityStateIds: null }
  );

  const { entityInfo } = useEntityOptions();

  useQuery(["getStatesType"], () => getStates(), {
    onSuccess: (data) => {
      setStates(data.data);
    },
    refetchOnMount: true,
  });

  const { isLoading: entityTableLoading } = useQuery(
    ["entityTableDashboard", queryParams],
    () => getEntityDashboardDetails({ ...queryParams, type: "table" }),
    {
      onSuccess: (res: AxiosResponse) => {
        setTableRows(
          res?.data?.stats.map((items, idx) => ({
            id: idx,
            sno: idx + 1,
            entityName: items.entity,
            state: items.state,
            totalBlocks: items.totalNumber,
            totalBlocksArea: items.totalArea,
            numberDemandNotePending: items.totalNumberOfGenerateDemandNote,
            areaDemandNotePending: items.totalAreaOfGenerateDemandNote,
            numberPaymentPending: items.totalNumberOfPaymentPending,
            areaPaymentPending: items.totalAreaOfPaymentPending,
            numberPaymentDone: items.totalNumberOfPaymentDone,
            areaPaymentDone: items.totalAreaOfPaymentDone,
            totalAreaOfGenerateDemandNote: items.totalAreaOfGenerateDemandNote,
            totalNumberOfGenerateDemandNote:
              items.totalNumberOfGenerateDemandNote,
            totalAreaOfVerificationPending:
              items.totalAreaOfVerificationPending,
            totalNumberOfVerificationPending:
              items.totalNumberOfVerificationPending,
            totalAreaOfDemandNotePending: items.totalAreaOfDemandNotePending,
            totalNumberOfDemandNotePending:
              items.totalNumberOfDemandNotePending,
            totalAreaOfDemandNoteReleased: items.totalAreaOfDemandNoteReleased,
            totalNumberOfDemandNoteReleased:
              items.totalNumberOfDemandNoteReleased,
          }))
        );
      },
      onError: () => {},
      refetchOnMount: true,
    }
  );

  const { data: entityDashboard, isLoading: entityDashboardLoading } = useQuery(
    ["entityDashboard", queryParams],
    () => getEntityDashboardDetails({ ...queryParams, type: "boxes" }),
    {
      onSuccess: (res: AxiosResponse) => {},
      onError: () => {},
      refetchOnMount: true,
    }
  );

  const formattedData = useMemo(
    () => formatDataForBarChart(entityDashboard?.data?.stats),
    [entityDashboard?.data?.stats]
  );

  const dashboardTableData: DashBoardTable = {
    topHeader: [
      "",
      "All Selected Blocks",
      "Cost Est. Pending From SFD",
      "Cost Est. Verification Pending",
      "Cost Est. Received From SFD",
      "Demand Note Released",
      "Payment Pending",
      "Payment Received ",
    ],
    header: [
      "S.No",
      "Entity Name",
      "State",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
      "No",
      "Area (ha)",
    ],
    data: tableRows,
  };

  const styles = getStyles(defaultStyles);
  useEffect(() => {
    setIsTabLoading(true);
  }, []);

  useEffect(() => {
    setFiltersState(entityDashboard?.data?.state);
    setfilterEntities(entityDashboard?.data.entities);
  }, [entityDashboard]);

  useEffect(() => {
    saveFilters({ queryParams, filterKey, entityfilterKey });
  }, [queryParams, filterKey, entityfilterKey]);

  return (
    <>
      <Box {...styles("topHeader")}>
        <Box
          sx={{
            marginBottom: "5px",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {filtersState && (
              <Box
                sx={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                Selected States:-
                {filtersState?.map((filterState) => {
                  return (
                    <Box
                      sx={{
                        height: "46px",
                        padding: "11px",
                        width: "fit-content",
                        border: "1px solid grey",
                        borderRadius: "24px",
                        backgroundColor: "#eee",
                      }}
                    >
                      {filterState}
                    </Box>
                  );
                })}
              </Box>
            )}
            {filterEntities && (
              <Box
                sx={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                Selected Entities:-
                {filterEntities?.map((filterState) => {
                  return (
                    <Box
                      sx={{
                        height: "46px",
                        padding: "11px",
                        width: "fit-content",
                        border: "1px solid grey",
                        borderRadius: "24px",
                        backgroundColor: "#eee",
                      }}
                    >
                      {filterState}
                    </Box>
                  );
                })}
              </Box>
            )}
          </Box>
          <Box sx={{ display: "flex", gap: "8px" }}>
            <MultiSelect
              options={states}
              value={filterKey.projectStateIds}
              onChange={(e: any) => {
                setFilterKey((prevFilter) => {
                  const newState = {
                    ...prevFilter,
                    projectStateIds: e.length ? e : null,
                  };

                  setQueryParams({
                    ...queryParams,
                    stateIds: newState?.projectStateIds,
                  });

                  return newState;
                });
              }}
            />
            <MultiSelect
              options={entityInfo}
              label={"Filter By Entity"}
              value={entityfilterKey.entityIds}
              onChange={(e: any) => {
                entitySetFilterKey((prevFilter) => {
                  const newState = {
                    ...prevFilter,
                    entityIds: e.length ? e : null,
                  };

                  setQueryParams({
                    ...queryParams,
                    entityIds: newState?.entityIds,
                  });

                  return newState;
                });
              }}
            />
          </Box>
        </Box>
        {!entityDashboardLoading ? (
          <Box
            sx={{ width: "100%", marginBottom: "20px", alignSelf: "center" }}
          >
            <StatusBarChart
              data={formattedData}
              label={"Status of Eco-Restoration Blocks Selected by Entity"}
            />
          </Box>
        ) : (
          <></>
        )}
        <Box {...styles("statsCardWrapper", { marginTop: "20px" })}>
          {entityDashboard?.data?.stats?.map((stat, index) => (
            <StatsCard
              key={index}
              title={`${stat?.description?.toUpperCase()}`}
              value={`${stat?.number}`}
              area={stat?.totalArea}
              customStyles={{ valueCard: styles("statsCard").sx }}
            />
          ))}
        </Box>
      </Box>

      {entityTableLoading ? (
        <DashboardChartSkeleton />
      ) : (
        <Box {...styles("dashboardTableWrapper")}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5" {...styles("heading")}>
              Status of Selected Eco-Restoration Blocks under GCP
            </Typography>
            <Button
              variant="outlined"
              onClick={() =>
                exportEntityTableToXlsx(
                  dashboardTableData.data,
                  dashboardTableData.header,
                  dashboardTableData.topHeader
                )
              }
            >
              Export
            </Button>
          </Box>
          <EntityDashBoardTable {...dashboardTableData} />
        </Box>
      )}
    </>
  );
};

export default Entity;
